const yup = require("yup");

// Schema for createcollegerules
const createDepartmentRules = yup.object({
  college: yup.string().min(2, "Minimum of 2 characters expected").required("Code is required"),
  code: yup.string().min(2, "Minimum of 2 characters expected").required("Code is required"),
  name: yup.string().min(2, "Minimum of 2 characters expected").required("Name is required"),
  status: yup.boolean().required("Status is required"),
  isacademic: yup.boolean().required("IsAcademic is required"),
});

// Schema for createdeanrule
const createHodRule = yup.object({
  staff: yup.string().required("Staff is required"),
  department: yup.string().required("Department is required"),
});

module.exports = {
  createDepartmentRules,
  createHodRule,
};
